import React, {useEffect, useState} from 'react';
import * as ScrollToTopStyle from "./scrollToTop.module.scss";
import ArrowUp from "../../../images/icons/up-arrow-white.svg"

function ScrollToTop() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      setIsScrolled(scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <div className={`${ScrollToTopStyle.floatingButton} ${isScrolled ? ScrollToTopStyle.floatingButton_visible : ''}`}>
      <div className={ScrollToTopStyle.floatingButton__circle} onClick={()=>scrollToTop()}>
        <img src={ArrowUp} alt=""/>
      </div>
    </div>
  );
}

export default ScrollToTop;